export const pickClassIcon = (classId: string, iconNames: string[]): string => {
  if (!iconNames.length) return '';

  let hash = 0;
  for (let index = 0; index < classId.length; index++) {
    hash = (hash * 31 + classId.charCodeAt(index)) >>> 0;
  }

  return iconNames[hash % iconNames.length];
};

export const resolveClassIcon = (classId: string, storedIcons: Map<string, string>, iconNames: string[]): string =>
  storedIcons.get(classId) ?? pickClassIcon(classId, iconNames);
